import React, {useEffect, useState} from 'react';
import {updateHeader, updateUrl, hideEditProduct} from '../../../store/actions/main';
import {connect} from 'react-redux';
import {updateModellIndexVordaecher, selectImageCategory} from '../../../store/actions/vordaecher';
import {glasvordaecher_auswahl} from '../../../../assets/images/data';
import ModalPopUp from '../../../module/modalPopUp';
import {StepComponent} from '../../../module/step_component';
import {ProductInfo} from '../../../module/productInfo';
import Button from '@material-ui/core/Button';


const Index = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    const closeModal = () => setShowModal(false);
    const closeModalInfo = () => setShowModalInfo(false);
    const [modell_index, setIndexModell] = useState(0);


    useEffect(() => {
        updateItems();
    })

    const updateItems = () => {
        props.updateHeader('Vordächer');
        let image_vordach_wrapper = document.querySelectorAll('.inner-modell-wrapper-vordaecher');

        //update checks wrapper
        for (let i = 0; i < image_vordach_wrapper.length; i++) {
            if (props.data[i].is_merkliste) {
                image_vordach_wrapper[i].classList.add('check');
            } else {
                image_vordach_wrapper[i].classList.remove('check');
            }
        }

       editProduct();

    }

    const editProduct = () => {
        let product = document.querySelectorAll('.button-select');
        let edit_modell_index = props.main_data[3].editProduct[0].editProductIndex;
        let isEditProduct = props.main_data[3].editProduct[0].isEditProduct;

        if (isEditProduct) {
            product[edit_modell_index].click();
            props.hideEditProduct();
        }
   }

    const showStepper = ev => {
        let modell_titel = ev.currentTarget.getAttribute('titel');
        let modell_index = ev.currentTarget.getAttribute('index');

        if (modell_titel === 'Glasvordach mit Pfosten') props.updateUrl('Glasvordach mit Pfosten');
        else props.updateUrl('Vordächer');

        let imageCategory = ev.target.ownerDocument.images[modell_index].currentSrc;

        let imageCategoryObject = {
            image: imageCategory,
            index: modell_index
        }

        props.selectImageCategory(imageCategoryObject);
        props.updateModellIndex(modell_index);
        setShowModal(true);
    }

    const showInfo = ev => {
        let index = ev.currentTarget.getAttribute('index');
        setIndexModell(Number(index));
        setShowModalInfo(true);
    }



    //productinfo items
   let desc = <></>;

    return (
        <div className='product_main_wrapper'>
             <h2>Welches Vordachart?</h2>
             <div className='product_wrapper'>
                 {glasvordaecher_auswahl.map((elem, index) => (
                        <div key={index} className='inner-modell-wrapper'>
                            <p className='titel'>{elem.titel}</p>
                            <img className='img_vordaecher' src={elem.imgsrc} alt={elem.titel} />
                            <div className="button-wrapper">
                                <Button onClick={showStepper} index={index} titel={elem.titel} className='button button-select'>Konfigurator starten</Button>
                                <Button onClick={showInfo} index={index} className='button info'>Mehr Informationen</Button>
                            </div>
                        </div>
                 ))}
             </div>
             <ModalPopUp
                  title={glasvordaecher_auswahl[modell_index].titel}
                  class='modell'
                  component={<StepComponent />}
                  showModal={showModal}
                  hideModal={closeModal}
              />
              <ModalPopUp
                     title={"Produktbeschreibung - "+glasvordaecher_auswahl[modell_index].titel}
                     class='modell'
                     component={<ProductInfo
                                 type={"ein "+glasvordaecher_auswahl[modell_index].titel}
                                 desc={desc}
                                 desc_items={glasvordaecher_auswahl[modell_index].content}
                                 price={`Ab ${glasvordaecher_auswahl[modell_index].price.toFixed(2)}€`}
                                 />}
                     showModal={showModalInfo}
                     hideModal={closeModalInfo}
               />
        </div>
    )
}

const mapStateToProps = state => {
    return {
        data: state.vordaecherReducer.data,
        main_data: state.mainReducer.data
    }
}

const mapStateToDispatch = dispatch => {
    return {
        updateHeader: ev => dispatch(updateHeader(ev)),
        updateUrl: ev => dispatch(updateUrl(ev)),
        updateModellIndex: ev => dispatch(updateModellIndexVordaecher(ev)),
        hideEditProduct: () => dispatch(hideEditProduct()),
        selectImageCategory: ev => dispatch(selectImageCategory(ev))
    }
}

export default connect(mapStateToProps, mapStateToDispatch)(Index);